
  <div id="dragable" ref="draggable" class="common-input-title-group" style="width: 100%">

    <div class="common-input-title-group-title-frame">
      <div class="common-input-title-group-title">설문조사</div>
    </div>
    <draggable v-model="list" ghost-class="ghost" @click="onClickDrag($event)" style="width: 100%">
      <transition-group>
        <div v-for="(item, index) in list" v-bind:key="index" class="flex flex-row flex-wrap w-full gap-[5px] lg:gap-[10px] items-center mb-[15px]" @change="onChangeDrag($event)">
          <div class="yn-custom-select-wrapper">
            <div class="yn-custom-select">
              <button type="button" @click="clickFunc(event)">
                <span v-cloak>{{item.code ? item.name : '선택'}}</span>
                <div>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                       xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 9L12 15L6 9" stroke="#222222" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </button>
              <ul class="list-wrap">
                <li class="flex-shrink-0">
                  <ul>
                    <li v-for="(items, idx) in listCodes">
                      <div>
                        <a @mousedown="fnOnChangeTextAndValue(index, items.code);item.code=items.code">
                          <div>
                            <span v-cloak>{{items.name}}</span>
                          </div>
                        </a>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
<!--
          <select v-model="item.code" @change="fnOnChangeTextAndValue(index, $event.target.value)" style="magrin:0"
                  class="w-full text-[18px] border border-[#222] rounded-[16px] p-3 md:text-[16px] md:py-3 placeholder:text-[18px] placeholder:font-medium placeholder:text-[#999] focus:outline-[#7639DF]"
                  data-gtm-form-interact-field-id="0">

            <option v-for="(items, idx) in listCodes" :value="items.code" v-bind:key="idx">
              {{ items.name }}
            </option>
          </select>-->
          <!--                            <div class="td_input" style="float: left; width:20%;">
                                          <div class="select_form wd_p100">
                                              <label class="select_common">{{item.name}}</label>
                                              <select class="select_custom" v-model="item.code" @change="fnOnChangeTextAndValue(index, $event.target.value)">
                                                  <option v-for="(items, idx) in listCodes" :value="items.code" v-bind:key="idx">{{items.name}}</option>
                                              </select>
                                          </div>
                                      </div>-->

          <input v-model="item.text" type="text"
                 class="common-input-title-group-text flex flex-auto"
          >
          <input v-model="item.value" type="text" :disabled="item.code != 'MEANVSURNV00200'"
                 class="common-input-title-group-text flex flex-auto"
          >
          <!--                            <div style="width: 31%; float:left; margin-top: 10px; font-size: 9px;">
                                          <div style="width: 98%">
                                              <input type="text" class="form_style wd_p100"  v-model="item.text" tabindex="600">
                                          </div>
                                      </div>
                                       <div style="float:left; width:37%; margin-top: 10px; font-size: 9px;">
                                          <div style="width: 98%">
                                             <input type="text" class="form_style wd_p100" v-model="item.value" :disabled="item.code != 'MEANVSURNV00200'" tabindex="600">
                                          </div>
                                      </div>-->

          <div class="flex ml-auto">
            <button class="btn_sm_ghost" @click="fnOnClickRemoveAccodion($event, index);"
                    @keydown.enter="fnOnClickRemoveAccodion($event, index);">삭제
            </button>
          </div>
          <!--                            <div  style="float:left; width:5%; margin-top: 10px;">
                                          <a class="btn_item item_del wd_35 dp_inline cursor" @click="fnOnClickRemoveAccodion($event, index);" tabindex="600" @keydown.enter="fnOnClickRemoveAccodion($event, index);">삭제</a>
                                      </div>-->
        </div>
      </transition-group>
    </draggable>
    <div style="float:right; margin:0 1% 3%" v-if="isExpinfo">
      <!--                 <a class="btn btn_sm btn_orange cursor" @click="fnOnClickAddAccodion($event, list.length + 1);"  tabindex="600" @keydown.enter="fnOnClickAddAccodion($event, list.length + 1);">추가</a>-->
      <button class="btn_sm_primary" @click="fnOnClickAddAccodion($event, list.length + 1);" tabindex="600"
              @keydown.enter="fnOnClickAddAccodion($event, list.length + 1);">추가
      </button>
    </div>
    <div style="float:right; margin:0 1% 3%" v-if="!isExpinfo">
      <button class="btn_sm_primary" @click="fnOnClickAddAccodion($event, list.length + 1);" tabindex="600"
              @keydown.enter="fnOnClickAddAccodion($event, list.length + 1);">추가
      </button>
      <!--                 <a class="btn btn_sm btn_purple cursor" @click="fnOnClickAddAccodion($event, list.length + 1);"  tabindex="600" @keydown.enter="fnOnClickAddAccodion($event, list.length + 1);">추가</a>-->
    </div>
  </div>
